<mat-card>
  @if (sessionService.client(); as selectedClient) {
    <div class="select-client-header flex">
      <span i18n="@@switch.client.change">Current:</span> <span>{{ selectedClient.name }}</span>
    </div>
  }
  @if (selectables(); as selList) {
    <mat-card-content>
      <dmb-filter
        [listItems]="selList"
        placeholder="Search Client"
        i18n-placeholder="@@switch.client.search"
        (dataChange)="select($event)"
        (cancelled)="close()"></dmb-filter>
    </mat-card-content>
  }
</mat-card>
